import Helpers from '../Helpers'
import ButtonCounter from '../ButtonCounter'

class ResultsParty {
    constructor(changeEvent) {
        const self = this
        this.changeEvent = changeEvent
        this.members = []
        Array.from(document.getElementsByClassName('results-aside__your-party-options')[0].children).forEach(el => {
            this.members.push(new ButtonCounter(el))
        });

        this.childAges = new ResultsPartyChildAges(document.getElementsByClassName('results-aside__children-ages')[0])
        this.babyFriendly = document.getElementsByClassName('results-aside__babyCheckbox')[0]

        this.listeners()
    }

    listeners() {
        const self = this
        new Helpers(this.members.map(m => m.control)).eventListener(e => {
                self.changeEvent('party')
        }, 'change')
        

        new Helpers(this.childAges.control).eventListener(e => {
            self.changeEvent('party')
        }, 'party-change')

        new Helpers(this.babyFriendly).eventListener(e => {
            self.changeEvent('party')
        },'change')
    }

    getValues() {
        let values = {}
        this.members.forEach(m => {
            const value = m.getValue()
            if (value != null && value != '0') {
                values[m.code] = value
            }
        })

        if (this.childAges.getValue().min != '') {
            values.cFrom = this.childAges.getValue().min
            values.cTo = this.childAges.getValue().max
        }

        values.baby = this.babyFriendly.checked ? 'Y' : null

        return values
    }


    getNonDefaultValues() {
        let values = {}
        this.members.forEach(m => {
            const value = m.getValue()
            if (value != null && value != m.defaultValue) {
                values[m.code] = value
            }
        })

        if (this.childAges.getValue().min != '') {
            values.cFrom = this.childAges.getValue().min
            values.cTo = this.childAges.getValue().max
        }

        if (this.babyFriendly.checked) {
            values.baby = 'Y'
        }

        return values
    }

    setValues(values) {

        this.members.forEach(member => {
            const value = values[member.code]

            if (value != undefined) {
                member.setValue(value)
            } else {
                member.reset()
            }
        })

        this.childAges.setMin(values['cFrom'] || '')
        this.childAges.setMax(values['cTo'] || '')

        this.babyFriendly.checked = values['baby'] == 'Y'
    }
}



class ResultsPartyChildAges {
    constructor(control) {
        this.control = control
        this.minAge = control.getElementsByTagName('select')[0]
        this.maxAge = control.getElementsByTagName('select')[1]

        this.changeEvents()
    }

    getValue() {
        return {
            'min': this.minAge.value,
            'max': this.maxAge.value
        }
    }

    changeEvents() {
        const self = this
        new Helpers(this.minAge).eventListener((e) => {
            self.minChange()
        }, 'change')

        new Helpers(this.maxAge).eventListener((e) => {
            self.maxChange()
        }, 'change')
    }

    minChange() {
        //clear all disabled values in max
        //Array.from(this.maxAge.getElementsByTagName('option')).forEach(o => {
        //    o.disabled = false
        //})
        if (this.minAge.value == '') {
            // clear max
            this.maxAge.value = ''
        } else {
            if (parseInt(this.maxAge.value) < parseInt(this.minAge.value) || this.maxAge.value == '') {
                this.maxAge.value = this.minAge.value
            }

            // disable max options below this value
            //Array.from(this.maxAge.getElementsByTagName('option')).forEach(o => {
            //    if (parseInt(o.value) < parseInt(this.minAge.value)) {
            //        o.disabled = true
            //    }
            //})
        }
        this.raiseEvent()
    }

    maxChange() {
        //clear all disabled values in max
        //Array.from(this.minAge.getElementsByTagName('option')).forEach(o => {
        //    o.disabled = false
        //})
        if (this.maxAge.value == '') {
            // clear max
            this.minAge.value = ''
        } else {
            if (parseInt(this.minAge.value) > parseInt(this.maxAge.value) || this.minAge.value == '') {
                this.minAge.value = this.maxAge.value
            }
            // disable max options below this value
            //Array.from(this.minAge.getElementsByTagName('option')).forEach(o => {
            //    if (parseInt(o.value) > parseInt(this.maxAge.value)) {
            //        o.disabled = true
            //    }
            //})
        }
        this.raiseEvent()
    }


    raiseEvent() {
        this.control.dispatchEvent(new CustomEvent('party-change'))
    }

    setMin(value) {
        this.minAge.value = value
    }

    setMax(value) {
        this.maxAge.value = value
    }
}

export default ResultsParty